<script>
    import { onMount, onDestroy } from 'svelte'
    import { url, params, afterPageLoad } from '@sveltech/routify'
    import { element, svg_element } from 'svelte/internal'
    import { homeURL, apiURL } from '../../store.js'
    import { fireHashChange, getHash } from '../../js/hash-scroll.js'
    import { hexToRgb } from '../../js/util.js'
    import SidebarItem from './SidebarItem.svelte'
    import PublicationSearchBar from '../inputs/PublicationSearchBar.svelte'
    import PublicationFilter from '../inputs/PublicationFilter.svelte'
    import ResourcesFilter from '../inputs/ResourcesFilter.svelte'

    export let page
    export let sectionView
    export let menuShow

    let svg
    const pageColourRGB = hexToRgb(page.circuit_color)
    const activeElements = []

    onMount(() => {
        [...svg.querySelectorAll("[id^='active--inject-'] path, [id^='active--inject-'] circle")]
            .forEach(element => {
                if (element.style.fill == 'rgb(255, 255, 255)' || element.style.fill == '#FFFFFF') {
                    activeElements.push(element)
                }
            })
        svg.addEventListener('click', catchAnyClick)
    })

    onDestroy(() => {
        svg.removeEventListener('click', catchAnyClick)
    })

    function catchAnyClick (event) {
        if (event.srcElement.nodeName == 'A') {
            try {
                menuShow = false
                if (menuShow) {
                    document.querySelector('.tab svg').style.transform = 'rotate(0deg)'
                } else {
                    document.querySelector('.tab svg').style.transform = 'rotate(180deg)'
                }
            } catch (err) {
            // pass when on desktop and the query selector above throws error
            }
        }
    }

    function handleClick (event) {
        const sectionItems = []
        activeElements.forEach((element, index) => {
            if (index < pageSections.length) {
                const clientRect = element.getBoundingClientRect()
                const x = (clientRect.left + (clientRect.width / 2)) * -1
                const y = 0
                element.style.transition = 'transform 0.2s ease'
                element.style.transform = `translate( ${x}px, ${y}px)`
            } else {
                element.style.display = 'none'
            }
        })
    }

    function handleMouseEnter (event) {
        activeElements.forEach(element => {
            element.style.fill = pageColourRGB
        })
        this.querySelector('.title').style.color = page.circuit_color
    }

    function handleMouseLeave (event) {
        activeElements.forEach(element => {
            element.style.fill = 'rgb(255, 255, 255)'
        })
        this.querySelector('.title').style.color = 'black'
    }
</script>

<div class="circuitWrapper" bind:this={svg} style="--pageColor: {page.circuit_color}">
    {#if !sectionView}
        <a href={$url('/' + page.title.toLowerCase())} class="circuit {page.title.toLowerCase()}"
            on:mouseenter={handleMouseEnter}
            on:mouseleave={handleMouseLeave}
            on:click={handleClick}
        >
            <img
                class="mainMenuCircuit"
                src="{apiURL}{page.circuit_file.url}"
                alt={page.circuit_file.title}
            />
            <p class="title">{page.title}</p>
        </a>
    {:else}
        {#if page.title == 'Publications'}
            <div class="inputSection">
                <SidebarItem {page} index={1} label={'Filter By'} />
                <PublicationFilter pubsCategories={page.categories} />
            </div>
            <div class="inputSection">
                <SidebarItem {page} index={0} label={'Search:'} />
                <PublicationSearchBar />
            </div>
            {#if page.externalLinks}
                <div class="inputSection externalLinks">
                    <SidebarItem {page} index={2} label={'Catalogs:'} />
                    {#each page.externalLinks as link}
                        <a class="externalLink" href={link.value.url} target="_blank">
                            {link.value.display_text}
                        </a>
                    {/each}
                </div>
            {/if}

        {:else if page.title == 'Teaching'}
            <SidebarItem {page} index={0} hash={'courses'} label={page.titleCourses} />
            <SidebarItem {page} index={1} hash={'outreach'} label={page.titleOutreach} />
            {#each page.sections as section, i}
                <div class="pageSection">
                    <SidebarItem
                        {page}
                        index={2 + i}
                        hash={getHash(section.title)}
                        label={section.title}
                    />
                </div>
            {/each}

        {:else if page.title == 'Resources'}
            {#each page.sections as section, i}
                <SidebarItem {page} index={i} hash={getHash(section.title)} label={section.title} />
            {/each}
            <SidebarItem {page} index={0} hash={'imagesandmovies'} label={'Images and Movies'} />
            <ResourcesFilter resourceCategories={page.categories} />

        {:else if page.title == 'News'}
            <SidebarItem {page} index={1} hash={'labupdates'} label={page.UpdatesTitle} />
            <SidebarItem {page} index={2} hash={'alabatwork'} label={page.LabAtWorkTitle} />
            <SidebarItem {page} index={3} hash={'tshirts'} label={'T-Shirts'} />

        {:else if page.title == 'People'}
            <SidebarItem {page} index={1} hash={'faculty'} label={'Faculty'} />
            <SidebarItem {page} index={2} hash={'postdocs'} label={'Postdocs'} />
            <SidebarItem {page} index={3} hash={'gradstudents'} label={'Grad Students'} />
            <SidebarItem {page} index={4} hash={'staff'} label={'Staff'} />
            <SidebarItem {page} index={5} hash={'alumni'} label={'Alumni'} />
            <SidebarItem {page} index={6} hash={'contact'} label={'Contact'} />

        {:else}
            {#each page.sections as section, i}
                <SidebarItem
                    {page}
                    index={i}
                    hash={getHash(section.title)}
                    label={section.title}
                />
                {#if typeof section.sections !== 'undefined'}
                    {#each section.sections as subSection, index}
                        <SidebarItem
                            {page}
                            hash={getHash(subSection.title)}
                            label={subSection.title}
                            subSection={true}
                        />
                    {/each}
                {/if}
            {/each}
        {/if}
    {/if}
</div>

<style lang="scss">
@import "../../styles/vars";

.circuit {
    width:100%;
    text-decoration: none;
    color: black;
    display: flex !important;
    align-items: center;
    justify-items: center;
    flex-direction: column;
}
.circuit:hover {
    cursor: pointer;
}

.title {
    margin: 0 0 0.5rem 0;
    width: 100%;
    text-align: center;
    font-size: 1.8em;
    font-family: Ysabeau;
}
.sectionsSvg {
    position: absolute;
}

.inputSection {
    margin: 20px 0;
}

:global( .sectionsSvg g:not([id^='active--inject-']) ) {
    display: none;
}

.externalLinks a {
    display: block;
    font-family: 'Ysabeau';
    font-size: 1.5rem;
    text-decoration: none;
    color: black;
}
.circuitWrapper {
    width: 100%;
    max-height: 100%;
    a {
        width: 100%;
        height: 100%;
        display: block;
    }
}

@include respond-to(computer) {
    :global(svg), .mainMenuCircuit {
        max-height: calc(44vh - 88px);
    }
}
@include respond-to(phone) {
    :global(svg), .mainMenuCircuit {
        max-height: calc(28vh - 58px);
    }
    .inputSection {
        margin: 0.5rem;
    }
    .title {
        font-size: 1.4rem;
        margin-top: 0;
        margin-bottom: 0.75rem;
    }
    .externalLink {
        font-size: 1rem;
        display: inline-block;
        margin-right: 1rem;
    }
}

</style>
